exports.components = {
  "component---src-templates-static-page-jsx": () => import("./../../../src/templates/static-page.jsx" /* webpackChunkName: "component---src-templates-static-page-jsx" */)
}

